import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import {
    ContactSupportDialogSectionType,
    ContactSupportOptionType,
} from '@fi-shared/fi-support/fi-contact-support-dialog/fi-contact-support-dialog.component';
import { FiContactSupportSectionBase } from '@fi-shared/fi-support/fi-contact-support-dialog/fi-contact-support-section-base';
import { ISectionCardData } from '@fi-shared/fi-section-card/fi-section-card';

@Component({
    selector: 'fi-contact-support-feedback-section',
    template: `
        <div class="section-header">
          <fi-contact-support-section-header
            [sectionHeaderText]="'support.feedback_section_header' | fiAppText"
            (onCloseDialog)="closeDialog()"
            (onGoBack)="goBack()"
            [isBackButtonShown]="true"
            >
          </fi-contact-support-section-header>
        </div>
        
        <p class="section-description">{{ 'support.feedback_section_description' | fiAppText }}</p>
        
        <div class="section-content-container">
          @for (availableContactOption of availableContactOptions; track availableContactOption) {
            <fi-section-card
              class="cursor-pointer"
              [contentCardData]="availableContactOption"
              >
            </fi-section-card>
          }
        </div>
        `,
    styleUrls: ['./fi-contact-support-feedback-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-contact-support-feedback-section' },
    standalone: false,
})
export class FiContactSupportFeedbackSectionComponent extends FiContactSupportSectionBase {
    availableContactOptions: ISectionCardData[] = [
        {
            headerTextLabel: this.appTextService.get('support.option_feedback_internal_header'),
            subheaderTextLabel: this.appTextService.get('support.option_feedback_internal_description'),
            id: ContactSupportOptionType.FeedbackInternal,
            onClick: () => {
                this.setCurrentSupportSectionType(ContactSupportDialogSectionType.Email);
                this.setCurrentSupportOptionType(ContactSupportOptionType.FeedbackInternal);
            },
        },
        {
            headerTextLabel: this.appTextService.get('support.option_feedback_chainformation_header'),
            subheaderTextLabel: this.appTextService.get('support.option_feedback_chainformation_description'),
            id: ContactSupportOptionType.FeedbackChainformation,
            onClick: () => {
                this.setCurrentSupportSectionType(ContactSupportDialogSectionType.Email);
                this.setCurrentSupportOptionType(ContactSupportOptionType.FeedbackChainformation);
            },
        },
    ];
}
